
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52.01 38.03"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M51 0H19.07A1.06 1.06 0 0018 1.06V10H6.93a1.05 1.05 0 00-.89.49L.18 19.67a1.06 1.06 0 00-.17.57v12s-.13 1.06.46.77h4.05a5.81 5.81 0 005.7 5 5.81 5.81 0 005.7-5h18.65a5.8 5.8 0 005.7 5C43.1 38 46 34 46 34h5a1.05 1.05 0 001-1.06V1.06A1.05 1.05 0 0051 0zM20 2h30v22H20zm-9.78 33.91a3.68 3.68 0 113.68-3.68 3.68 3.68 0 01-3.68 3.68zM18 31h-1.88a5.67 5.67 0 00-11.18 0H2V20.5L7.43 12H18zm22.26 4.91A3.68 3.68 0 1144 32.23a3.68 3.68 0 01-3.73 3.68zM50 31h-4a5.73 5.73 0 00-11.39 0H20v-6h30z","fill":"#2b938c","data-name":"Layer 4"}})])])
          )
        }
      }
    